<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="row">
        <div class="col-12" *ngIf="loading">
            <ngx-skeleton-loader [theme]="{
                        height: '244px',
                        margin:'0 0 24px'
                    }">
            </ngx-skeleton-loader>
        </div>

        <div class="col-12" *ngIf="!loading">
            <div class="dash-details-card" *ngIf="documentsLoading">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>

            <div class="dash-details-card" *ngIf="!documentsLoading">
                <app-empty-content
                    [isVisible]="!hasDocumentsWithData(documents)"
                    title="Nenhum documento encontrado"
                    description="Não foi encontrado nenhum documento nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <div class="table-scroll-container"
                    *ngIf="hasDocumentsWithData(documents)">
                    <table>
                        <thead>
                            <tr class="alternative-header">
                                <th>Arquivo</th>
                                <th>Emissão</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let document of documents">
                                <tr class="alternative-header"
                                    *ngFor="let item of document.data">
                                    <td style="max-width: 500px;">
                                        {{item.type?.slug_name || getDocumentLabel(document.slug)}}
                                    </td>
                                    <td>
                                        <div class="dash-card-item">
                                            <div class="dash-card-item-content">
                                                <div
                                                    class="dash-card-item-content-title">
                                                    {{formateDate(item.created_at)}}
                                                </div>
                                            </div>
                                        </div>
                                    </td>

                                    <td>
                                        <div class="d-flex align-items-center justify-content-end"
                                            style="gap: 12px;">
                                            <app-tooltip *ngIf="item.file"
                                                text="Visualizar">
                                                <button
                                                    class="button datasheet-button"
                                                    (click)="openUsPerson(item.file)"
                                                    style="font-size: 0.85rem;">
                                                    <svg-icon
                                                        src="assets/images/icon-eye.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                            <!-- <app-tooltip
                                                *ngIf="document.slug === 'compliance-documents' && canManageComplianceDocuments"
                                                text="Download">
                                                <button
                                                    class="button datasheet-button"
                                                    (click)="downloadComplianceDocument(item)"
                                                    style="font-size: 0.85rem;">
                                                    <i
                                                        class="fas fa-download" ></i>
                                                </button>
                                            </app-tooltip> -->
                                            <app-tooltip
                                                *ngIf="document.slug === 'compliance-documents' && canManageComplianceDocuments"
                                                text="Excluir">
                                                <button
                                                    class="button datasheet-button"
                                                    (click)="deleteComplianceDocument(item)"
                                                    [disabled]="deletingDocumentId === item.id"
                                                    style="font-size: 0.85rem;">
                                                    <svg-icon
                                                        src="assets/images/icon-trash.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                        </div>
                                    </td>
                                </tr>

                                <tr *ngIf="document.data.length === 0">
                                    <td>
                                        {{getDocumentLabel(document.slug)}}
                                    </td>
                                    <td>--</td>
                                    <td></td>
                                </tr>
                            </ng-container>
                        </tbody>
                        <app-spacer [bottom]="28"></app-spacer>
                    </table>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Lado esquerdo - Versão Principal -->
        <div class="col-6">
            <ng-container *ngIf="mainLoading">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!mainLoading">
                <ng-container *ngIf="approvalService.approvalData.mainVersion">
                    <!-- Tabela de Documentos -->
                    <div class="dash-details-card">
                        <app-empty-content
                            [isVisible]="!hasDocumentsWithData(mainDocuments)"
                            title="Nenhum documento encontrado"
                            description="Não foi encontrado nenhum documento nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <div class="table-scroll-container"
                            *ngIf="hasDocumentsWithData(mainDocuments)">
                            <table>
                                <thead>
                                    <tr class="alternative-header">
                                        <th>Arquivo</th>
                                        <th>Emissão</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container
                                        *ngFor="let document of mainDocuments">
                                        <tr class="alternative-header"
                                            *ngFor="let item of document.data">
                                            <td style="max-width: 500px;">
                                                {{item.type?.slug_name || getDocumentLabel(document.slug)}}
                                            </td>
                                            <td>
                                                <div class="dash-card-item">
                                                    <div
                                                        class="dash-card-item-content">
                                                        <div
                                                            class="dash-card-item-content-title">
                                                            {{formateDate(item.created_at)}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    class="d-flex align-items-center justify-content-end">
                                                    <button
                                                        class="button datasheet-button"
                                                        (click)="openUsPerson(item.file)">
                                                        <svg-icon
                                                            src="assets/images/icon-eye.svg"></svg-icon>
                                                    </button>
                                                    <button
                                                        *ngIf="document.slug === 'compliance-documents' && canManageComplianceDocuments"
                                                        class="button datasheet-button ms-2"
                                                        (click)="downloadComplianceDocument(item)"
                                                        title="Download">
                                                        <i
                                                            class="fas fa-download"></i>
                                                    </button>
                                                    <button
                                                        *ngIf="document.slug === 'compliance-documents' && canManageComplianceDocuments"
                                                        class="button datasheet-button ms-2"
                                                        (click)="deleteComplianceDocument(item)"
                                                        [disabled]="deletingDocumentId === item.id"
                                                        title="Excluir">
                                                        <i
                                                            class="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr *ngIf="document.data.length === 0"
                                            class="alternative-header">
                                            <td>{{getDocumentLabel(document.slug)}}
                                            </td>
                                            <td>--</td>
                                            <td></td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                                <app-spacer [bottom]="28"></app-spacer>
                            </table>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!approvalService.approvalData.mainVersion">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container *ngIf="comparingDataLoading">
                <div class="dash-details-card">
                    <div class="table-scroll-container">
                        <table>
                            <thead>
                                <tr class="alternative-header">
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '150px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '100px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '30px', height: '30px', borderRadius: '50%' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let i of [1,2,3]"
                                    class="alternative-header">
                                    <td>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '250px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '150px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '30px', height: '30px', borderRadius: '50%' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!comparingDataLoading">
                <ng-container
                    *ngIf="approvalService.approvalData.comparingVersion">
                    <!-- Tabela de Documentos -->
                    <div class="dash-details-card">
                        <app-empty-content
                            [isVisible]="!hasDocumentsWithData(comparingDocuments) && !comparingDataLoading"
                            title="Nenhum documento encontrado"
                            description="Não foi encontrado nenhum documento nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <div class="table-scroll-container"
                            *ngIf="hasDocumentsWithData(comparingDocuments)">
                            <table>
                                <thead>
                                    <tr class="alternative-header">
                                        <th>Arquivo</th>
                                        <th>Emissão</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container
                                        *ngFor="let document of comparingDocuments">
                                        <tr class="alternative-header"
                                            *ngFor="let item of document.data"
                                            [class]="item.compareClass"
                                            [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                            <td style="max-width: 500px;">
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <svg-icon
                                                        src="assets/images/icon-check-filled.svg"
                                                        *ngIf="item.compareClass === 'row-compare-added'"
                                                        class="text-success"></svg-icon>
                                                    <svg-icon
                                                        src="assets/images/icon-times-circle.svg"
                                                        *ngIf="item.compareClass === 'row-compare-removed'"
                                                        class="text-danger"></svg-icon>
                                                    <svg-icon
                                                        src="assets/images/icon-warning.svg"
                                                        *ngIf="item.compareClass === 'row-compare-modified'"
                                                        class="text-warning"></svg-icon>
                                                    <span>{{item.type?.slug_name || getDocumentLabel(document.slug)}}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="dash-card-item">
                                                    <div
                                                        class="dash-card-item-content">
                                                        <div class="dash-card-item-content-title"
                                                            style="display: flex; align-items: center; gap: 6px;">
                                                            <svg-icon
                                                                src="assets/images/icon-warning.svg"
                                                                *ngIf="isFieldChanged(item, 'created_at')"
                                                                class="text-warning"></svg-icon>
                                                            <span>{{formateDate(item.created_at)}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div
                                                    class="d-flex align-items-center justify-content-end">
                                                    <button
                                                        class="button datasheet-button"
                                                        (click)="openUsPerson(item.file)">
                                                        <svg-icon
                                                            src="assets/images/icon-eye.svg"></svg-icon>
                                                    </button>
                                                    <button
                                                        *ngIf="document.slug === 'compliance-documents' && canManageComplianceDocuments"
                                                        class="button datasheet-button ms-2"
                                                        (click)="downloadComplianceDocument(item)"
                                                        title="Download">
                                                        <svg-icon
                                                            src="assets/images/icon-download.svg"></svg-icon>
                                                    </button>
                                                    <button
                                                        *ngIf="document.slug === 'compliance-documents' && canManageComplianceDocuments"
                                                        class="button datasheet-button ms-2"
                                                        (click)="deleteComplianceDocument(item)"
                                                        [disabled]="deletingDocumentId === item.id"
                                                        title="Excluir">
                                                        <svg-icon
                                                            src="assets/images/icon-trash.svg"></svg-icon>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr *ngIf="document.data.length === 0"
                                            class="alternative-header"
                                            [class]="document.compareClass">
                                            <td>
                                                <div
                                                    style="display: flex; align-items: center; gap: 6px;">
                                                    <svg-icon
                                                        src="assets/images/icon-check-filled.svg"
                                                        *ngIf="document.compareClass === 'row-compare-added'"
                                                        class="text-success"></svg-icon>
                                                    <svg-icon
                                                        src="assets/images/icon-times-circle.svg"
                                                        *ngIf="document.compareClass === 'row-compare-removed'"
                                                        class="text-danger"></svg-icon>
                                                    <svg-icon
                                                        src="assets/images/icon-warning.svg"
                                                        *ngIf="document.compareClass === 'row-compare-modified'"
                                                        class="text-warning"></svg-icon>
                                                    <span>{{item.type?.slug_name || getDocumentLabel(document.slug)}}</span>
                                                </div>
                                            </td>
                                            <td>--</td>
                                            <td></td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                                <app-spacer [bottom]="28"></app-spacer>
                            </table>
                        </div>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="!approvalService.approvalData.comparingVersion">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>

<app-side-modal [active]="showDocumentDetailsModal"
    [title]="selectedData ? selectedData.name : ''"
    (onClose)="toggleDocumentDetailsModal()" paddingBottom="30">
    <ng-container *ngIf="selectedData">
        <div class="container">
            <div class="row">
                <div class="col-12 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        Testemunhas
                    </span>

                    <span class="dash-details-card-item-title">
                        {{formatWitnesses(selectedData.witness)}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12 d-flex flex-column">
                    <span class="dash-details-card-item-subtitle">
                        Status
                    </span>

                    <span class="dash-details-card-item-title">
                        {{selectedData.status}}
                    </span>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>
            </div>
        </div>
    </ng-container>
</app-side-modal>

<app-carbon-warning-modal [active]="showDeleteModal"
    [title]="getDeleteModalTitle()" [message]="getDeleteModalMessage()"
    [confirmText]="getDeleteConfirmText()" [cancelText]="getDeleteCancelText()"
    [confirmAction]="confirmDeleteDocument.bind(this)"
    [cancelAction]="closeDeleteModal.bind(this)" (onClose)="closeDeleteModal()">
</app-carbon-warning-modal>

<app-document-visualizer-modal [active]="showDocumentModal"
    [file]="selectedDocument" (onClose)="closeDocumentModal()">
</app-document-visualizer-modal>